import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { CreateStandingsConfiguration } from "~pages/StandingsConfigurations/types/upsertStandingsConfiguration.ts";
import type { StandingConfiguration, StandingConfigurationResponse } from "~types/standingConfiguration.ts";

export const useCreateStandingsConfiguration = () => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();

  return useMutation<StandingConfiguration | true, Error, CreateStandingsConfiguration>({
    mutationFn: async (data) => {
      const response = await request<StandingConfigurationResponse>(`${sport}/o/${organizationId}/standings/configurations`, {
        method: "POST",
        body: data,
      });

      return response?.data?.[0] ?? true;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["standingsConfigurations", sport, organizationId] });
    },
  });
};
